/**
 * @generated SignedSource<<fabd676a52ce23240ba534415e094b36>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductCarousel_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_itemSearch">;
  readonly " $fragmentType": "BuyerProductCarousel_itemSearch";
};
export type BuyerProductCarousel_itemSearch$key = {
  readonly " $data"?: BuyerProductCarousel_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductCarousel_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a775ce25a6a01dc2875f6aa578fd8cb5";

export default node;
